export const transformCreditCardDto = card => {
  var _card$default;

  return {
    id: "".concat(card.external_code || card.id),
    lastFour: card.last4 || card.last_four,
    isDefault: (_card$default = card.default) !== null && _card$default !== void 0 ? _card$default : card.is_default,
    brand: card.brand,
    expirationMonth: card.expiration_month,
    expirationYear: card.expiration_year,
    isSingleUse: card.single_use,
    expired: card.expired
  };
};
export const transformCreditCardDtos = cards => cards.map(transformCreditCardDto);